import { render, staticRenderFns } from "./iframeLink.vue?vue&type=template&id=18dfe5ed"
import script from "./iframeLink.vue?vue&type=script&lang=js"
export * from "./iframeLink.vue?vue&type=script&lang=js"
import style0 from "./iframeLink.vue?vue&type=style&index=0&id=18dfe5ed&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports